import React, { useState, useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useTheme } from "../../contexts/ThemeContext";
import CodeAnimation from "../common/CodeAnimation";

const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showAnimation, setShowAnimation] = useState(true);
  const { theme } = useTheme();
  const animationRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Hide animation after 5 seconds
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 5000);

    // Save current scroll position
    const scrollPosition = window.scrollY;

    // Prevent scrolling to animation
    if (animationRef.current) {
      animationRef.current.scrollIntoView({
        block: "center",
        behavior: "auto",
      });
      // Restore scroll position
      window.scrollTo(0, scrollPosition);
    }

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`flex h-screen ${
        theme === "dark" ? "bg-gray-900" : "bg-gray-100"
      }`}
    >
      <Sidebar
        isOpen={sidebarOpen}
        onToggle={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />

        <main
          className={`flex-1 overflow-x-hidden overflow-y-auto p-6 ${
            theme === "dark" ? "bg-gray-900" : "bg-gray-50"
          }`}
        >
          <div className="container mx-auto">
            {showAnimation && (
              <div ref={animationRef} className="mb-6 max-w-3xl mx-auto">
                <CodeAnimation
                  code={`// Welcome to AetherFlow Systems
import { Project, Task, Developer } from '@aetherflow/core';

// Initialize a new project
const project = new Project({
  title: 'E-commerce Platform',
  client: 'AcmeCorp',
  deadline: new Date('2024-12-31')
});

// Add tasks to the project
project.addTask(new Task({
  title: 'User Authentication',
  priority: 'high',
  assignedTo: 'developer@example.com'
}));

// Track progress
project.onUpdate((stats) => {
  // Progress tracking active
});

// Start development
project.start();
// Project initialized successfully!`}
                />
              </div>
            )}
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
